import type { RefObject } from 'react'
import { Pagination } from '@sunwebgroup/uds-ui/pagination'
import * as React from 'react'
import { useIntl } from 'react-intl'
import { useFilterableCarsAvailable } from '@/scopes/checkout/filterableCars/domain/hooks'
import { useDebouncedCallback } from '@/scopes/common/components/hooks/useDebouncedCallback'

export function CarsPagination({ scrollToElement }: { scrollToElement: RefObject<HTMLDivElement | null> }) {
  const { goToNextPage, goToPreviousPage, goToPage, currentPage, totalPages } = useFilterableCarsAvailable()
  const intl = useIntl()

  const scrollToTop = useDebouncedCallback(() => {
    requestAnimationFrame(() => {
      if (scrollToElement && scrollToElement.current) {
        scrollToElement.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    })
  }, 100)

  const handlePreviousPage = () => {
    goToPreviousPage()
    scrollToTop()
  }
  const handleNextPage = () => {
    goToNextPage()
    scrollToTop()
  }
  const handleGoToPage = (pageNumber: number) => {
    goToPage(pageNumber)
    scrollToTop()
  }

  if (totalPages <= 1)
    return

  return (
    <Pagination
      currentPage={currentPage}
      totalPages={totalPages}
      goToPreviousPage={handlePreviousPage}
      goToNextPage={handleNextPage}
      goToPage={handleGoToPage}
      previousPageLabel={intl.formatMessage({ id: 'pagination_go_to_previous_page_label' })}
      nextPageLabel={intl.formatMessage({ id: 'pagination_go_to_next_page_label' })}
      pageLabel={(pageNumber: number) => intl.formatMessage({ id: 'pagination_go_to_page_label' }, { pageNumber })}
    />
  )
}
